import bus from '../util/eventBus';

async function load(requestData) {
  const formData = new FormData();
  formData.append('data', JSON.stringify(requestData));

  const req = await fetch('/wp-json/facetwp/v1/fetch', {
    method: 'POST',
    body: formData,
  });

  return req.text();
}

const getFacets = template => {
  const terms = {};
  const items = template.querySelectorAll('[data-filter-type]');
  if (items) {
    items.forEach(item => {
      terms[item.dataset.filterName] = [];

      const selections = item.querySelectorAll('.c-filter__item.is-selected');
      if (selections) {
        selections.forEach(selection => {
          terms[item.dataset.filterName].push(selection.dataset.value);
        });
      }
    });
  }

  return terms;
};

const filterActions = (elm, requestData) => {
  if (elm.classList.contains('is-disabled')) {
    return;
  }

  const newRequestData = requestData;

  elm.classList.toggle('is-selected');

  newRequestData.facets = getFacets(elm.closest('[data-facet-template]'));
  newRequestData.settings.first_load = false;
  newRequestData.query_args.paged = 1;

  // eslint-disable-next-line no-unused-vars,no-shadow
  const response = load(newRequestData).then(response => {
    const data = JSON.parse(response);
    // eslint-disable-next-line no-use-before-define
    build(data, elm.closest('[data-facet-template]'), newRequestData);
    bus.emit('ewg-facet-filtering');
  });
};

const pagingActions = async (elm, requestData) => {
  const newRequestData = requestData;

  if (elm.dataset.pageNext !== elm.dataset.pageCurrent) {
    newRequestData.facets = getFacets(elm.closest('[data-facet-template]'));
    newRequestData.settings.first_load = false;
    newRequestData.query_args.paged = elm.dataset.pageNext;

    const response = await load(newRequestData);
    const data = JSON.parse(response);

    // eslint-disable-next-line no-use-before-define
    await build(
      data,
      elm.closest('[data-facet-template]'),
      newRequestData,
      true,
      true,
    );

    bus.emit('ewg-load-more');
  }
};

const build = (
  data,
  wrapper,
  requestData,
  renderResults = true,
  append = false,
) => {
  const result = wrapper.querySelector('[data-facet-results]');
  const filter = wrapper.querySelector('[data-facet-filter]');
  const pager = wrapper.querySelector('[data-facet-pager]');

  if (renderResults) {
    if (!append) {
      result.innerHTML = '';
    }
    data.results.forEach(entry => {
      result.innerHTML += entry;
    });
    bus.emit('ewg-facet-loaded', true);
  }

  if (filter) {
    filter.innerHTML = '';
    data.facetsHtml.forEach(facet => {
      filter.innerHTML += facet;

      const links = filter.querySelectorAll('.c-filter__item');
      links.forEach(link => {
        link.addEventListener('click', e => {
          const targetElement = e.target || e.srcElement;
          filterActions(targetElement, requestData);
        });
      });
    });
  }

  if (pager) {
    const loadMore = pager.querySelector('button');
    loadMore.setAttribute('data-page-current', data.pager.page);
    loadMore.setAttribute('data-page-next', data.pager.page + 1);

    if (data.pager.page === data.pager.total_pages) {
      loadMore.style.display = 'none';
    } else {
      loadMore.style.display = '';
    }

    loadMore.onclick = e => {
      const targetElement = e.target || e.srcElement;
      pagingActions(targetElement, requestData);
    };
  }
};

const init = () => {
  const facetTemplates = document.querySelectorAll('[data-facet-template]');
  if (facetTemplates) {
    facetTemplates.forEach(elm => {
      // eslint-disable-next-line no-unused-vars
      const wrapper = elm;
      const postType = elm.dataset.facetPostType;
      const postPerPage = elm.dataset.facetPpp;
      const postExclude = elm.dataset.facetExclude.split(',');
      const filter = elm.dataset.facetFilters.split(',');
      const eventFilter = elm.dataset.facetEventFilters
        ? elm.dataset.facetEventFilters.split(',')
        : [];
      const facets = {};

      filter.forEach(sFilter => {
        facets[sFilter] = [];
      });

      const requestData = {
        facets,
        query_args: {
          post_type: postType,
          orderby: 'post_date',
          order: 'DESC',
          post_status: 'publish',
          posts_per_page: postPerPage,
          post__not_in: postExclude,
          paged: 1,
        },
        settings: {
          first_load: true,
        },
      };

      if (postType === 'event') {
        const today = new Date();
        const yyyy = today.getFullYear();
        let mm = today.getMonth() + 1;
        let dd = today.getDate();

        if (dd < 10) dd = '0'.concat(dd);
        if (mm < 10) mm = '0'.concat(mm);

        const formattedToday = ''.concat(yyyy, mm, dd);

        requestData.query_args.meta_key = 'event_date';
        requestData.query_args.meta_compare = '>=';
        requestData.query_args.meta_value = formattedToday;
        requestData.query_args.orderby = 'meta_value';
        requestData.query_args.order = 'ASC';
        requestData.query_args.tag__in = eventFilter;
      }

      load(requestData).then(res => {
        const data = JSON.parse(res);
        build(data, elm, requestData, false);
      });
    });
  }
};
export default { init };



// WEBPACK FOOTER //
// ./src/scripts/modules/facet.js